import { ComboboxOption } from "@headlessui/react";
import { HiCheck } from "react-icons/hi2";

type Props<T extends { id: string; name: string }> = {
  option: T;
  children: React.ReactNode;
};

const ComboBoxCustomOption = <T extends { id: string; name: string }>({ option, children }: Props<T>) => {
  return (
    <ComboboxOption
      value={option}
      className={
        "group my-0.5 flex cursor-pointer select-none items-center justify-between gap-2 rounded px-3 py-2 font-medium text-primary data-[focus]:bg-secondary-hover data-[selected]:bg-secondary"
      }
    >
      {children}
      <HiCheck className="invisible size-6 shrink-0 fill-fg-brand-primary group-data-[selected]:visible" />
    </ComboboxOption>
  );
};

export default ComboBoxCustomOption;
